import { parseHours, serializeHours } from '../execution-units';

import './styles.scss';

interface ExecutionHourGridProps {
  // Stored comma string of hours (e.g. "10,15").
  value: string;
  // Called with the new comma string (ascending) on any tick.
  onChange: (commaString: string) => void;
}

const HOURS = Array.from({ length: 24 }, (_, h) => h);
const label = (h: number) => `${h.toString().padStart(2, '0')}:00`;

// A 24-cell grid of hour-of-day checkboxes replacing the free-text execution
// time input. Form state stays the comma string ("10,15") — this only parses
// it to ticked cells and re-serializes ascending on change.
export const ExecutionHourGrid = ({ value, onChange }: ExecutionHourGridProps) => {
  const selected = new Set(parseHours(value));

  const toggle = (hour: number) => {
    const next = new Set(selected);
    if (next.has(hour)) {
      next.delete(hour);
    } else {
      next.add(hour);
    }
    onChange(serializeHours(Array.from(next)));
  };

  return (
    <div className="execution-hour-grid" role="group" aria-label="Execution hours">
      {HOURS.map((hour) => {
        const isOn = selected.has(hour);
        return (
          <button
            key={hour}
            type="button"
            className={`execution-hour-cell ${isOn ? 'execution-hour-cell--on' : ''}`}
            aria-pressed={isOn}
            onClick={() => toggle(hour)}
          >
            {label(hour)}
          </button>
        );
      })}
    </div>
  );
};
